var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightModeWhiteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V1C11 0.447715 11.4477 0 12 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92891 3.51469C4.53838 3.12417 3.90522 3.12417 3.51469 3.51469C3.12417 3.90522 3.12417 4.53838 3.51469 4.92891L6.34312 7.75734C6.73365 8.14786 7.36681 8.14786 7.75734 7.75734C8.14786 7.36681 8.14786 6.73365 7.75734 6.34312L4.92891 3.51469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13H5C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11H1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 11.4477 18.4477 11 19 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H19C18.4477 13 18 12.5523 18 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6569 16.2426C17.2663 15.8521 16.6332 15.8521 16.2427 16.2426C15.8521 16.6331 15.8521 17.2663 16.2427 17.6568L19.0711 20.4852C19.4616 20.8758 20.0948 20.8758 20.4853 20.4852C20.8758 20.0947 20.8758 19.4616 20.4853 19.071L17.6569 16.2426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75734 17.6568C8.14786 17.2663 8.14786 16.6331 7.75734 16.2426C7.36681 15.8521 6.73365 15.8521 6.34312 16.2426L3.51469 19.071C3.12417 19.4616 3.12417 20.0947 3.51469 20.4852C3.90522 20.8758 4.53838 20.8758 4.92891 20.4852L7.75734 17.6568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 4.92891C20.8758 4.53838 20.8758 3.90522 20.4853 3.51469C20.0948 3.12417 19.4616 3.12417 19.0711 3.51469L16.2427 6.34312C15.8521 6.73365 15.8521 7.36681 16.2427 7.75734C16.6332 8.14786 17.2663 8.14786 17.6569 7.75734L20.4853 4.92891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeWhiteFill);
export default __webpack_public_path__ + "static/media/light-mode-white-fill.5ec2aba4dc023ac37a9e52789511272c.svg";
export { ForwardRef as ReactComponent };